import React from 'react';
import Icon from './ui/Icon';
import Reveal from './ui/Reveal';
import { footer } from '../data/content';

const headingClass = 'font-display text-sm font-semibold uppercase tracking-[0.22em] text-cream';

export default function Footer() {
  return (
    <footer id="contact" className="on-dark grain relative bg-ink-900 pt-20">
      <div className="shell relative grid gap-12 pb-14 sm:grid-cols-2 lg:grid-cols-4 lg:gap-14">
        <Reveal>
          <img
            src="/assets/logo-light.webp"
            alt="The TEEEM logo"
            width="480"
            height="422"
            loading="lazy"
            className="h-20 w-auto"
          />
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-cream/55">{footer.about}</p>
        </Reveal>

        <Reveal as="nav" delay={90} aria-labelledby="footer-links">
          <h2 id="footer-links" className={headingClass}>
            Quick Links
          </h2>
          <ul className="mt-6 space-y-3">
            {footer.quickLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="link-underline inline-block text-sm text-cream/55 transition-colors duration-300 hover:text-cream"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={180}>
          <h2 className={headingClass}>Contact Us</h2>
          <ul className="mt-6 space-y-4 text-sm text-cream/55">
            <li className="flex items-center gap-3.5">
              <Icon name="mail" className="h-[18px] w-[18px] shrink-0 text-gold" />
              <a href={`mailto:${footer.contact.email}`} className="transition-colors duration-300 hover:text-gold">
                {footer.contact.email}
              </a>
            </li>
            <li className="flex items-center gap-3.5">
              <Icon name="phone" className="h-[18px] w-[18px] shrink-0 text-gold" />
              <a href={`tel:${footer.contact.phoneHref}`} className="transition-colors duration-300 hover:text-gold">
                {footer.contact.phone}
              </a>
            </li>
            <li className="flex gap-3.5">
              <Icon name="pin" className="mt-0.5 h-[18px] w-[18px] shrink-0 text-gold" />
              <address className="not-italic leading-relaxed">
                {footer.contact.address.map((line) => (
                  <span key={line} className="block">
                    {line}
                  </span>
                ))}
              </address>
            </li>
          </ul>
        </Reveal>

        <Reveal delay={270}>
          <blockquote className="border-l-2 border-gold/40 pl-5 font-serif text-base italic leading-relaxed text-cream/60">
            {footer.verse.text}
            <footer className="mt-2 font-sans text-xs not-italic tracking-wide text-cream/60">
              {footer.verse.reference}
            </footer>
          </blockquote>
        </Reveal>
      </div>

      <div className="relative border-t border-cream/10 py-6">
        <p className="shell text-center text-xs tracking-wide text-cream/60">
          © {new Date().getFullYear()} TEEEM. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
